import NavBar from '@/components/Nav.vue';

import client from '@/configs/client.js';

export default {
    name: 'AboutPage',
    components: {
        NavBar,
    },
    data() {
        return {
            xinhua: client.xinhua
        }
    },
    methods: {
        logout() {
            this.$store.commit('setAuthorization', null);
            this.$router.replace('/');
        }
    }
}